<div class="home-container" [ngClass]="rootClassName">
  @if (lesson; as lessonObj) {
    <pop-ui-lesson-detail [lesson]="lessonObj" [navigation]="navigation" [(close)]="close" [@fadeInOut]></pop-ui-lesson-detail>
  } @else {
    <span class="home-status-container" [class.web]="isWeb">
      <pop-ui-status [(state)]="completionState" [@fastFade]></pop-ui-status>
      <pop-ui-date-picker [(activeDate)]="activeDate" (activeDateChange)="activeDateChange.emit($event)" [@fastFade]></pop-ui-date-picker>
    </span>

    @defer (when isLoaded) {
      <pop-ui-drawer [state]="state" [date]="activeDate" (handlebarAction)="handlebarAction.emit($event)" [@slideInOut]></pop-ui-drawer>
    } @placeholder (minimum 500ms){
      <nx-superprep-dot-flashing></nx-superprep-dot-flashing>
    }
  }
</div>

<div tourAnchor="anchor.first.session" class="centered-tour-element image"></div>
<div tourAnchor="anchor.add.lesson" class="centered-tour-element icon"></div>
